var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 6.5C12.2749 6.5 6 12.7749 6 20.5C6 28.2251 12.2749 34.5 20 34.5C27.7251 34.5 34 28.2251 34 20.5C34 12.7749 27.7251 6.5 20 6.5ZM13.8113 30.58C15.2185 28.5554 17.5303 27.3205 20 27.3205C22.4697 27.3205 24.7815 28.541 26.2031 30.58C24.3938 31.7 22.2831 32.3462 20 32.3462C17.7169 32.3462 15.6205 31.7 13.8113 30.58ZM27.9118 29.2877C26.0882 26.7031 23.159 25.1667 20 25.1667C16.841 25.1667 13.8974 26.7318 12.0882 29.2877C9.6759 27.1195 8.15385 23.9892 8.15385 20.5C8.15385 13.9667 13.4667 8.65385 20 8.65385C26.5333 8.65385 31.8462 13.9667 31.8462 20.5C31.8462 23.9892 30.3241 27.1195 27.9118 29.2877Z",
    fill: "#A3A1AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0018 12.2436C17.0295 12.2436 14.6172 14.6559 14.6172 17.6282C14.6172 20.6005 17.0295 23.0128 20.0018 23.0128C22.9741 23.0128 25.3864 20.6005 25.3864 17.6282C25.3864 14.6559 22.9741 12.2436 20.0018 12.2436ZM20.0018 20.859C18.2213 20.859 16.771 19.4087 16.771 17.6282C16.771 15.8477 18.2213 14.3974 20.0018 14.3974C21.7823 14.3974 23.2326 15.8477 23.2326 17.6282C23.2326 19.4087 21.7823 20.859 20.0018 20.859Z",
    fill: "#A3A1AA"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial);
export default __webpack_public_path__ + "static/media/social.dc5e0af3.svg";
export { ForwardRef as ReactComponent };